export default __webpack_public_path__ + "static/media/会议中心.bf8fd335.jpg";